import { useCallback } from 'react';

import {
  GeneratedGetDrawEntryIntentQuery,
  useGetDrawEntryIntentLazyQuery,
} from '../../../types/generated';
import {
  EntryIntentPollingController,
  useEntryIntentPolling,
} from './useEntryIntentPolling';

export type ConfirmedDrawEntryIntent = NonNullable<
  GeneratedGetDrawEntryIntentQuery['getDrawEntryIntent']
>;

export type DrawEntryConfirmationArgs = {
  onConfirmed: (intent: ConfirmedDrawEntryIntent) => Promise<void>;
};

export type DrawEntryConfirmationController = EntryIntentPollingController;

export const useDrawEntryConfirmation = ({
  onConfirmed,
}: DrawEntryConfirmationArgs): DrawEntryConfirmationController => {
  const [getDrawEntryIntent] = useGetDrawEntryIntentLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const read = useCallback(
    async (intentId: string) => {
      const { data, error } = await getDrawEntryIntent({
        variables: { drawEntryIntentId: intentId },
      });

      return { error, intent: data?.getDrawEntryIntent };
    },
    [getDrawEntryIntent],
  );

  return useEntryIntentPolling({
    label: 'Draw entry intent',
    onConfirmed,
    read,
  });
};
